import { AxiosService } from 'src/axios/axios.service';
import type { tAxiosCustomConfig } from 'src/axios/axios.types';
import { parseMarketingEligibility } from './SchedulingRiskWarning.functions';
import type { tMarketingEligibility } from './SchedulingRiskWarning.types';

/**
 * A little over bff-web's own 5 s bound on the upstream read, so a slow
 * whatsapp-business-service costs the warning, never a stuck modal.
 */
export const MARKETING_ELIGIBILITY_TIMEOUT_MS = 6000;

type tGetMarketingEligibilityRequest = {
  workspaceId: string;
  handle: string;
};

export const SchedulingRiskService = Object.freeze({
  /**
   * INT-1500 U13 (contract C8): bff-web's
   * GET /workspace/:wid/whatsapp-api/recipients/:handle/marketing-eligibility.
   * The handle is URL-encoded (a leading '+' travels as %2B, which bff-web
   * decodes). Rejects on any failure, and the caller fails open: an expected
   * refusal (no account, a 4xx relayed as is) is not reported to Sentry.
   */
  getMarketingEligibility: async function (
    request: tGetMarketingEligibilityRequest,
    config?: tAxiosCustomConfig,
  ): Promise<tMarketingEligibility | null> {
    const body = await AxiosService.get<unknown>(
      `/workspace/${request.workspaceId}/whatsapp-api/recipients/${encodeURIComponent(
        request.handle,
      )}/marketing-eligibility`,
      {
        timeout: MARKETING_ELIGIBILITY_TIMEOUT_MS,
        skipSentryCapture: true,
        ...config,
      },
    );
    return parseMarketingEligibility(body);
  },
});
